/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Partial demographics update. Every property is optional; supplying one changes it, omitting one leaves it alone. Dates use MatrixCare's M/D/YYYY wire format. Ids come from MatrixCareHomeHealthLookupsResponse.
 * @export
 * @interface MatrixCareAdmissionDemographicsUpdate
 */
export interface MatrixCareAdmissionDemographicsUpdate {
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    middle_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    suffix?: string;
    /**
     * 
     */
    nickname?: string;
    /**
     * 
     */
    preferred_pronouns?: string;
    /**
     * 
     */
    medical_record?: string;
    /**
     * 
     */
    formatted_ssn?: string;
    /**
     * MatrixCare wire format, M/D/YYYY.
     */
    date_of_birth?: string;
    /**
     * 
     */
    address_line?: string;
    /**
     * 
     */
    apt_or_suite?: string;
    /**
     * 
     */
    city?: string;
    /**
     * 
     */
    state_code?: string;
    /**
     * 
     */
    zip_code?: string;
    /**
     * 
     */
    country?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    home_phone?: string;
    /**
     * 
     */
    mobile_phone?: string;
    /**
     * MatrixCare wire format, M/D/YYYY. Mandatory on the vendor and cannot be cleared through this endpoint.
     */
    referral_date?: string;
    /**
     * 
     */
    scheduled_soc_date?: string;
    /**
     * 
     */
    physician_ordered_soc_date?: string;
    /**
     * 
     */
    facility_discharge_date?: string;
    /**
     * Element id from `genders`.
     */
    gender_id?: string;
    /**
     * Element id from `gender_identities`.
     */
    gender_identity_id?: string;
    /**
     * Element id from `sexual_orientations`.
     */
    sexual_orientation_id?: string;
    /**
     * Element id from `lives_alone_options`.
     */
    lives_alone_id?: string;
    /**
     * Element id from `marital_statuses`.
     */
    marital_status_id?: string;
    /**
     * Element id from `religions`.
     */
    religion_id?: string;
    /**
     * Element id from `facility_discharge_types`.
     */
    facility_discharge_type_id?: string;
    /**
     * Element ids from `races`. An empty array clears the selection.
     */
    race_ids?: Array<string>;
    /**
     * Element ids from `ethnicities`. An empty array clears the selection.
     */
    ethnicity_ids?: Array<string>;
    /**
     * 
     */
    for_observation_only?: boolean;
}

/**
 * Check if a given object implements the MatrixCareAdmissionDemographicsUpdate interface.
 */
export function instanceOfMatrixCareAdmissionDemographicsUpdate(value: object): value is MatrixCareAdmissionDemographicsUpdate {
    return true;
}

export function MatrixCareAdmissionDemographicsUpdateFromJSON(json: any): MatrixCareAdmissionDemographicsUpdate {
    return MatrixCareAdmissionDemographicsUpdateFromJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareAdmissionDemographicsUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'preferred_pronouns': json['preferred_pronouns'] == null ? undefined : json['preferred_pronouns'],
        'medical_record': json['medical_record'] == null ? undefined : json['medical_record'],
        'formatted_ssn': json['formatted_ssn'] == null ? undefined : json['formatted_ssn'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : json['date_of_birth'],
        'address_line': json['address_line'] == null ? undefined : json['address_line'],
        'apt_or_suite': json['apt_or_suite'] == null ? undefined : json['apt_or_suite'],
        'city': json['city'] == null ? undefined : json['city'],
        'state_code': json['state_code'] == null ? undefined : json['state_code'],
        'zip_code': json['zip_code'] == null ? undefined : json['zip_code'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'] == null ? undefined : json['email'],
        'home_phone': json['home_phone'] == null ? undefined : json['home_phone'],
        'mobile_phone': json['mobile_phone'] == null ? undefined : json['mobile_phone'],
        'referral_date': json['referral_date'] == null ? undefined : json['referral_date'],
        'scheduled_soc_date': json['scheduled_soc_date'] == null ? undefined : json['scheduled_soc_date'],
        'physician_ordered_soc_date': json['physician_ordered_soc_date'] == null ? undefined : json['physician_ordered_soc_date'],
        'facility_discharge_date': json['facility_discharge_date'] == null ? undefined : json['facility_discharge_date'],
        'gender_id': json['gender_id'] == null ? undefined : json['gender_id'],
        'gender_identity_id': json['gender_identity_id'] == null ? undefined : json['gender_identity_id'],
        'sexual_orientation_id': json['sexual_orientation_id'] == null ? undefined : json['sexual_orientation_id'],
        'lives_alone_id': json['lives_alone_id'] == null ? undefined : json['lives_alone_id'],
        'marital_status_id': json['marital_status_id'] == null ? undefined : json['marital_status_id'],
        'religion_id': json['religion_id'] == null ? undefined : json['religion_id'],
        'facility_discharge_type_id': json['facility_discharge_type_id'] == null ? undefined : json['facility_discharge_type_id'],
        'race_ids': json['race_ids'] == null ? undefined : json['race_ids'],
        'ethnicity_ids': json['ethnicity_ids'] == null ? undefined : json['ethnicity_ids'],
        'for_observation_only': json['for_observation_only'] == null ? undefined : json['for_observation_only'],
    };
}

export function MatrixCareAdmissionDemographicsUpdateToJSON(json: any): MatrixCareAdmissionDemographicsUpdate {
    return MatrixCareAdmissionDemographicsUpdateToJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsUpdateToJSONTyped(value?: MatrixCareAdmissionDemographicsUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'nickname': value['nickname'],
        'preferred_pronouns': value['preferred_pronouns'],
        'medical_record': value['medical_record'],
        'formatted_ssn': value['formatted_ssn'],
        'date_of_birth': value['date_of_birth'],
        'address_line': value['address_line'],
        'apt_or_suite': value['apt_or_suite'],
        'city': value['city'],
        'state_code': value['state_code'],
        'zip_code': value['zip_code'],
        'country': value['country'],
        'email': value['email'],
        'home_phone': value['home_phone'],
        'mobile_phone': value['mobile_phone'],
        'referral_date': value['referral_date'],
        'scheduled_soc_date': value['scheduled_soc_date'],
        'physician_ordered_soc_date': value['physician_ordered_soc_date'],
        'facility_discharge_date': value['facility_discharge_date'],
        'gender_id': value['gender_id'],
        'gender_identity_id': value['gender_identity_id'],
        'sexual_orientation_id': value['sexual_orientation_id'],
        'lives_alone_id': value['lives_alone_id'],
        'marital_status_id': value['marital_status_id'],
        'religion_id': value['religion_id'],
        'facility_discharge_type_id': value['facility_discharge_type_id'],
        'race_ids': value['race_ids'],
        'ethnicity_ids': value['ethnicity_ids'],
        'for_observation_only': value['for_observation_only'],
    };
}

